import type { TPermissionRequirement } from 'app/auth/types';
import type { ComponentType, JSX } from 'react';
import { Telemetry } from 'app/services/telemetry/Telemetry';

export type RouteId =
    | 'auth'
    | 'diary'
    | 'patient'
    | 'settings'
    | 'home'
    | string;
export type GuardFn = () => boolean | Promise<boolean>;
export type StackFactory = ComponentType<{}>;
export type RouteMeta = {
    placement: 'tab' | 'hidden';
    tabLabel?: string;
    tabIcon?:
    | string
    | ((args: { color: string; size: number; focused: boolean }) => JSX.Element);
    showIf?: GuardFn;
    order?: number;
};
export type ModuleRoute = {
    id: RouteId;
    Stack: StackFactory;
    initial?: boolean;
    required?: TPermissionRequirement;
    options?: object;
    meta: RouteMeta;
    screenNames?: string[];
};

// This array is initialized and populated in each module's route registry
// Each module registers its routes using the registerModuleRoute function below
export const MODULE_ROUTES: ModuleRoute[] = [];

export function getTabIdForScreen(screenName: string): string | null {
    for (const route of MODULE_ROUTES) {
        if (route.meta.placement === 'tab' && route.screenNames?.includes(screenName)) {
            return route.id;
        }
    }
    return null;
}

export const registerModuleRoute = (route: ModuleRoute) => {
    const existingIndex = MODULE_ROUTES.findIndex(r => r.id === route.id);
    if (existingIndex !== -1) {
        Telemetry.log('warning', `Route with ID '${route.id}' already exists. Replacing it.`);
        MODULE_ROUTES[existingIndex] = route;
    } else {
        MODULE_ROUTES.push(route);
    }
};